<template>
<el-button 
    class="hydroware-edit-button"
    size="small" 
    title="Edit"
    value="edit"
    v-bind="$attrs"
    v-on="$listeners">
    <i class="el-icon-edit "></i>
    <span v-if="text">{{text}}</span>
</el-button>
</template>
<script>
export default {
    props: ['text']
  }
</script> 


// WEBPACK FOOTER //
// hydroware-edit-button.vue?c944fb96